import * as React from 'react';

import { classNames } from 'uitk-react-utils';

interface ToolbarRegionProps {
  className: string;
  children: any;
}

export const ToolbarRegion: React.FunctionComponent<ToolbarRegionProps> = ({ className, children }) => (
  <section className={classNames('toolbar-region pwa-toolbar__row', { [className]: className })}>{children}</section>
);
